import { HistoricalMedicalLeave } from '@dreryk/egabinet-ezla-frontend-api';

import { Ordering } from '@dreryk/react-common';

export const DEFAULT_TABLE_ORDERINGS: Ordering<HistoricalMedicalLeave>[] = [
   {
      descending: true,
      property: 'creationDateTime',
   },
];
